export default __webpack_public_path__ + "static/stride-logo-fd1adcfad352867b18486a1b63129d59.png";